import React from "react";
import { Icon } from "@iconify/react";
import "./layouts-styles.css";

/**
 * Empty state.
 *
 * An empty screen is an invitation to act, so every use should say what
 * is missing in this specific list and, where there is one, offer the
 * action that fills it — not antd's generic grey "No data" box.
 */
const BaseEmpty = ({
  icon = "tabler:folder-open",
  title = "Nothing here yet",
  description,
  action,
}) => (
  <div className="state-block">
    <span className="state-mark">
      <Icon icon={ icon } width={ 28 } />
    </span>
    <span className="state-title">{ title }</span>
    { description && <p className="state-desc">{ description }</p> }
    { action && <div className="state-action">{ action }</div> }
  </div>
);

export default BaseEmpty;
